// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__3La4L","footer":"App_footer__29Fsv","announcement":"App_announcement__1d1pc"};